/* Tee Factory header behaviour — vanilla JS, no dependencies.
   Fixed: null-guards (initCart line ~181 crash), delegated close buttons,
   outside-click close for all drawers, robust mobile sub-menu toggles. */
(function () {
  'use strict';

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-tf-announcement]').forEach(function (bar) {
      if (bar.dataset.tfBound) return; bar.dataset.tfBound = '1';
      var slides = [].slice.call(bar.querySelectorAll('.tf-announcement__slide'));
      if (slides.length < 2) return;
      var i = 0, interval = parseInt(bar.dataset.speed, 10) || 4000, timer = null;
      function go(next) {
        var cur = slides[i];
        cur.classList.add('is-leaving'); cur.classList.remove('is-active');
        i = (next + slides.length) % slides.length;
        slides.forEach(function (s, idx) { if (idx !== i) s.classList.remove('is-leaving'); });
        slides[i].classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 500);
      }
      function start() { if (bar.dataset.autoplay === 'true') timer = setInterval(function () { go(i + 1); }, interval); }
      function stop() { clearInterval(timer); }
      var p = bar.querySelector('.tf-announcement__arrow--prev'), n = bar.querySelector('.tf-announcement__arrow--next');
      if (p) p.addEventListener('click', function () { stop(); go(i - 1); start(); });
      if (n) n.addEventListener('click', function () { stop(); go(i + 1); start(); });
      bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------------- Desktop dropdown / mega menu ---------------- */
  function initDesktopMenu() {
    var items = document.querySelectorAll('.tf-menu__item.tf-has-panel');
    var timers = new WeakMap();
    items.forEach(function (item) {
      if (item.dataset.tfBound) return; item.dataset.tfBound = '1';
      var link = item.querySelector('.tf-menu__link');
      function open() { clearTimeout(timers.get(item)); items.forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); if (link) link.setAttribute('aria-expanded', 'true'); }
      function scheduleClose() { timers.set(item, setTimeout(function () { item.classList.remove('is-open'); if (link) link.setAttribute('aria-expanded', 'false'); }, 150)); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      if (link) link.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 991px)').matches) {
          var isOpen = item.classList.contains('is-open'); e.preventDefault();
          items.forEach(function (o) { o.classList.remove('is-open'); });
          if (!isOpen) open(); else item.classList.remove('is-open');
        }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') items.forEach(function (o) { o.classList.remove('is-open'); }); });
    document.addEventListener('click', function (e) { if (!e.target.closest('.tf-menu__item.tf-has-panel')) items.forEach(function (o) { o.classList.remove('is-open'); }); });
  }

  /* ---------------- Mobile drawer ---------------- */
  function initMobileDrawer() {
    var drawer = document.querySelector('.tf-mobile-drawer');
    var burger = document.querySelector('.tf-burger');
    if (!drawer || !burger || drawer.dataset.tfBound) return;
    drawer.dataset.tfBound = '1';

    function open() { openPanel(drawer); }
    function close() { closeAll(); }

    burger.addEventListener('click', open);

    // Guard: close button may not exist in every markup variant.
    var closeBtn = drawer.querySelector('.tf-mobile-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    // Delegated fallback so a dynamically rendered close button still works.
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.tf-mobile-drawer__close')) close();
    });

    // Sub-menu toggles — robust submenu lookup + preventDefault so an
    // anchor/label inside the toggle doesn't navigate or scroll.
    drawer.querySelectorAll('.tf-mobile-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var exp = btn.getAttribute('aria-expanded') === 'true';
        var willOpen = !exp;
        btn.setAttribute('aria-expanded', String(willOpen));
        var sub =
          (btn.nextElementSibling && btn.nextElementSibling.classList && btn.nextElementSibling.classList.contains('tf-mobile-submenu'))
            ? btn.nextElementSibling
            : (btn.parentElement && btn.parentElement.querySelector(':scope > .tf-mobile-submenu'))
              || (btn.parentElement && btn.parentElement.querySelector('.tf-mobile-submenu'));
        if (sub) {
          sub.classList.toggle('is-open', willOpen);
          // Inline max-height fallback in case the theme CSS relies on JS
          // for the expand animation. Harmless if CSS already handles it.
          if (willOpen) { sub.style.maxHeight = sub.scrollHeight + 'px'; }
          else { sub.style.maxHeight = ''; }
        }
        btn.classList.toggle('is-open', willOpen);
      });
    });
  }

  /* ---------------- Sticky shadow ---------------- */
  function initSticky() {
    var header = document.querySelector('.tf-header'); if (!header || header.dataset.tfBound) return;
    header.dataset.tfBound = '1';
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Shared open/close ---------------- */
  var DRAWER_SEL = '.tf-panel, .tf-mobile-drawer, .tf-cart-drawer, .tf-search-drawer';

  function closeAll() {
    document.querySelectorAll(DRAWER_SEL).forEach(function (p) { p.classList.remove('is-open'); });
    var ov = document.querySelector('.tf-overlay'); if (ov) ov.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function openPanel(panel) {
    if (!panel) return;
    document.querySelectorAll(DRAWER_SEL).forEach(function (p) { if (p !== panel) p.classList.remove('is-open'); });
    panel.classList.add('is-open');
    var ov = document.querySelector('.tf-overlay'); if (ov) ov.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function money(cents, currency) {
    var code = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var val = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + val + (code ? ' ' + code : '');
  }

  /* ---------------- Predictive search (right panel) ---------------- */
  function initSearch() {
    var toggle = document.querySelector('[data-tf-search-toggle]');
    var drawer = document.querySelector('.tf-search-drawer');
    if (!toggle || !drawer || drawer.dataset.tfBound) return;
    drawer.dataset.tfBound = '1';
    var input = drawer.querySelector('.tf-search-drawer__input');
    var body = drawer.querySelector('.tf-panel__body');
    var clearBtn = drawer.querySelector('.tf-search-drawer__clear');
    var rootUrl = (drawer.dataset.rootUrl || '/').replace(/\/+$/, '');
    var debounce;

    toggle.addEventListener('click', function (e) { e.preventDefault(); openPanel(drawer); if (input) setTimeout(function () { input.focus(); }, 120); });

    var closeBtn = drawer.querySelector('.tf-search-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeAll);
    drawer.addEventListener('click', function (e) { if (e.target.closest('.tf-search-drawer__close')) closeAll(); });

    if (clearBtn && input && body) clearBtn.addEventListener('click', function () { input.value = ''; body.innerHTML = ''; input.focus(); });

    if (input && body) input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { body.innerHTML = ''; return; }
      debounce = setTimeout(function () { fetchResults(q); }, 250);
    });

    function fetchResults(q) {
      var url = rootUrl + '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      body.innerHTML = '<div class="tf-search-empty">Searching…</div>';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        render(q, (data.resources && data.resources.results) || {});
      }).catch(function () { body.innerHTML = '<div class="tf-search-empty">Search unavailable.</div>'; });
    }

    function render(q, res) {
      var html = '';
      var queries = res.queries || [], products = res.products || [], collections = res.collections || [];
      if (queries.length) {
        html += '<div class="tf-search-section-title">Search suggestions</div><ul class="tf-search-suggestions">';
        queries.forEach(function (item) {
          var text = item.text || item.styled_text || '';
          html += '<li><button type="button" data-q="' + text.replace(/"/g, '&quot;') + '">' + text + '</button></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<div class="tf-search-section-title">Products</div><div class="tf-search-products">';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = (p.price_min != null ? p.price_min : p.price);
          var priceHtml = price != null ? '<div class="tf-search-product__price">from ' + money(price) + '</div>' : '';
          html += '<a class="tf-search-product" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') +
            '<div class="tf-search-product__title">' + p.title + '</div>' + priceHtml + '</a>';
        });
        html += '</div>';
      }
      if (collections.length) {
        html += '<div class="tf-search-section-title">Collections</div><ul class="tf-search-collections">';
        collections.forEach(function (c) { html += '<li><a href="' + c.url + '">' + c.title + '</a></li>'; });
        html += '</ul>';
      }
      if (!html) html = '<div class="tf-search-empty">No results for “' + q + '”.</div>';
      body.innerHTML = html;
      body.querySelectorAll('.tf-search-suggestions button').forEach(function (b) {
        b.addEventListener('click', function () { input.value = b.dataset.q; fetchResults(b.dataset.q); });
      });
    }

    var footerLink = drawer.querySelector('[data-tf-search-all]');
    if (footerLink) footerLink.addEventListener('click', function (e) {
      var q = input ? input.value.trim() : ''; if (!q) { e.preventDefault(); return; }
      footerLink.setAttribute('href', rootUrl + '/search?q=' + encodeURIComponent(q));
    });
  }

  /* ---------------- Cart drawer (AJAX) ---------------- */
  function initCart() {
    var trigger = document.querySelector('[data-tf-cart-toggle]');
    var drawer = document.querySelector('.tf-cart-drawer');
    if (!drawer || drawer.dataset.tfBound) return;
    drawer.dataset.tfBound = '1';
    var body = drawer.querySelector('.tf-panel__body');
    var footer = drawer.querySelector('.tf-panel__footer');
    var rootUrl = (drawer.dataset.rootUrl || '/').replace(/\/+$/, '');
    var threshold = parseInt(drawer.dataset.freeShipping, 10) || 0; // cents
    var busy = false;

    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); openPanel(drawer); loadCart(); });

    // FIX: the close button is (re)rendered inside renderCart, so it can be
    // null right now. Bind any static one AND delegate on the drawer so both
    // the initial and re-rendered close buttons work.
    var staticClose = drawer.querySelector('.tf-cart-drawer__close');
    if (staticClose) staticClose.addEventListener('click', closeAll);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.tf-cart-drawer__close')) closeAll();
    });

    function loadCart() {
      if (!body) return;
      fetch(rootUrl + '/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('.tf-cart-count').forEach(function (el) { el.textContent = count; });
    }

    function change(key, qty) {
      if (busy) return; busy = true;
      fetch(rootUrl + '/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { busy = false; renderCart(cart); })
        .catch(function () { busy = false; });
    }

    function saveNote(note) {
      fetch(rootUrl + '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note })
      });
    }

    function renderCart(cart) {
      if (!body || !footer) return;
      updateHeaderCount(cart.item_count);
      var cur = cart.currency;

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML =
          '<div class="tf-cart-drawer__head"><h2 class="tf-cart-drawer__title">Your cart</h2>' +
          '<button class="tf-cart-drawer__close" aria-label="Close">&times;</button></div>' +
          '<div class="tf-cart-empty">Your cart is empty.</div>';
        footer.innerHTML = '<a class="tf-cta" href="' + rootUrl + '/collections">Continue shopping</a>';
        rebind(cart);
        return;
      }

      var head = '<div class="tf-cart-drawer__head"><h2 class="tf-cart-drawer__title">Your cart' +
        '<sup class="tf-cart-drawer__count">' + cart.item_count + '</sup></h2>' +
        '<button class="tf-cart-drawer__close" aria-label="Close">&times;</button></div>';

      var ship = '';
      if (threshold > 0) {
        var remaining = threshold - cart.total_price;
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        var boxSvg = '<svg viewBox="0 0 24 24" fill="none"><path d="M3 7l9-4 9 4-9 4-9-4Zm0 0v10l9 4 9-4V7" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
        ship = '<div class="tf-ship">' + boxSvg +
          (remaining > 0 ? '<span>Only <b>' + money(remaining, cur) + '</b> away from free shipping!</span>'
                         : '<span><b>You’ve unlocked free shipping!</b></span>') + '</div>' +
          '<div class="tf-ship-track"><div class="tf-ship-fill" style="width:' + pct + '%"></div></div>';
      }

      var items = cart.items.map(function (it) {
        var img = it.image || (it.featured_image && it.featured_image.url) || '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="tf-cart-item__variant">' + it.variant_title + '</div>' : '';
        return '<div class="tf-cart-item" data-key="' + it.key + '">' +
          (img ? '<img class="tf-cart-item__img" src="' + img + '" alt="" loading="lazy">' : '<span class="tf-cart-item__img"></span>') +
          '<div><a class="tf-cart-item__title" href="' + it.url + '">' + it.product_title + '</a>' + variant +
          '<div class="tf-cart-item__price">' + money(it.final_price, cur) + '</div>' +
          '<div class="tf-cart-item__row">' +
            '<span class="tf-qty"><button type="button" data-act="dec" aria-label="Decrease">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-act="inc" aria-label="Increase">+</button></span>' +
            '<button type="button" class="tf-cart-item__remove" data-act="remove">Remove</button>' +
          '</div></div></div>';
      }).join('');

      var notesVal = cart.note || '';
      var notes = '<button type="button" class="tf-cart-notes-toggle">+ Add order notes</button>' +
        '<textarea class="tf-cart-notes' + (notesVal ? ' is-open' : '') + '" placeholder="Special instructions for your order">' + notesVal + '</textarea>';

      body.innerHTML = head + ship + items + notes;
      footer.innerHTML =
        '<div class="tf-cart-subtotal"><span>Subtotal</span><span>' + money(cart.total_price, cur) + '</span></div>' +
        '<div class="tf-cart-taxnote">Tax included. Shipping calculated at checkout.</div>' +
        '<a class="tf-cta" href="' + rootUrl + '/checkout">Checkout</a>';

      rebind(cart);
    }

    function rebind(cart) {
      // Close handled by delegation above; no per-render binding needed.
      body.querySelectorAll('.tf-cart-item').forEach(function (row) {
        var key = row.dataset.key;
        var item = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        var qty = item ? item.quantity : 1;
        row.querySelectorAll('[data-act]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var act = btn.dataset.act;
            if (act === 'inc') change(key, qty + 1);
            else if (act === 'dec') change(key, Math.max(0, qty - 1));
            else if (act === 'remove') change(key, 0);
          });
        });
      });
      var toggle = body.querySelector('.tf-cart-notes-toggle');
      var ta = body.querySelector('.tf-cart-notes');
      if (toggle && ta) {
        toggle.addEventListener('click', function () { ta.classList.toggle('is-open'); if (ta.classList.contains('is-open')) ta.focus(); });
        ta.addEventListener('change', function () { saveNote(ta.value); });
      }
    }

    // Load count on page load
    loadCart();
    // Expose so custom "add to cart" buttons can refresh + open
    window.tfOpenCart = function () { openPanel(drawer); loadCart(); };
    window.tfRefreshCart = loadCart;
  }

  /* ---------------- Global ---------------- */
  function initGlobal() {
    if (document.documentElement.dataset.tfGlobalBound) return;
    document.documentElement.dataset.tfGlobalBound = '1';

    var ov = document.querySelector('.tf-overlay');
    if (ov) ov.addEventListener('click', closeAll);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // Reliable outside-click close that works even if .tf-overlay is missing
    // or sits behind a drawer. Ignores clicks inside a drawer or on a trigger.
    document.addEventListener('click', function (e) {
      var anyOpen = document.querySelector(DRAWER_SEL.split(', ').map(function (s) { return s + '.is-open'; }).join(', '));
      if (!anyOpen) return;
      if (e.target.closest(DRAWER_SEL)) return;
      if (e.target.closest('[data-tf-cart-toggle],[data-tf-search-toggle],.tf-burger')) return;
      closeAll();
    });
  }

  function boot() {
    initAnnouncement(); initDesktopMenu(); initMobileDrawer(); initSticky();
    initGlobal(); initSearch(); initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
